<template>
  <div class="searchPage">
    <div class="searchPageWarrp">
      <div class="searchHead">
        <div class="searchInput">
          <form action="/">
            <van-search
              v-model="value"
              show-action
              placeholder="请输入搜索关键词"
              @search="onSearch"
              @cancel="onCancel"
              @input="changeEvent"
              clearable
            >
              <template #right-icon>
                <van-icon v-if="value" name="clear" @click="clearSearch" />
              </template>
            </van-search>
          </form>
        </div>
      </div>
      <!-- 历史搜索 -->
      <div class="searchHistory" v-show="!isSearching && historyList?.length">
        <div class="searchHistoryTittle">
          <h2>历史搜索</h2>
          <img
            src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/historydelicon.png"
            alt=""
            @click="deleteHistory"
          />
        </div>

        <div class="searchHistoryContent" v-show="historyList?.length">
          <ul v-show="historyList && historyList.length">
            <li v-for="(item, index) in historyList" :key="index" @click="historyDetail(item)">
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
      <!-- 热搜词 -->
      <div class="searchHot" v-show="!isSearching && newList?.length">
        <img src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/hotsearchicon.png" alt="" />
        <div class="searchHotContent">
          <ul v-show="newList && newList.length">
            <li v-for="(item, index) in newList" :key="index" @click="AddhotDetail(item)">
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
      <!-- 搜索结果 -->
      <div class="searchListContent" v-show="isSearching">
        <div class="noCourse" v-show="showCourse">
          <div>
            <img src="@/assets/img/noData/noSearch.png" alt="" />
            <div>抱歉哦，没有找到你想要的内容</div>
          </div>
        </div>
        <div class="courseMain" v-show="!showCourse">
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div v-for="(item, keys) in courseMainList" :key="keys">
              <CombinationCard v-if="item.setType === 1" :key="keys" :item="item" />
              <HotCourseCard v-else :key="keys" :item="item" />
            </div>
          </van-list>
        </div>
      </div>
      <!-- 广告位 -->
      <div class="adbox" v-show="adDataObject.id && !isSearching">
        <img :src="adDataObject.images || ''" alt="" @click="jumpCourseDetail" />
      </div>
      <!-- 热门好课排行 -->
      <div class="hotCourseSection" v-show="courseInfoData?.length && !isSearching">
        <img
          class="hotCourseTitle"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/%E5%A5%BD%E8%AF%BE%E6%8E%92%E8%A1%8C%402x.png"
          alt=""
        />
        <!-- <h2>热门好课排行</h2> -->
        <div class="course-list">
          <div v-for="(item, keys) in courseInfoData" :key="keys">
            <CombinationCard v-if="item.setType === 1" :key="keys" :item="item" />
            <HotCourseCard v-else :key="keys" :item="item" />
          </div>
        </div>
      </div>
      <Foot />
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import {
  reqNewHotWord,
  reqHotClick,
  reqSearchListNew,
  reqHistoryList,
  reqDeleteHistory,
} from '@/api/search';
import { reqReceiveCoupon } from '@/api/coupon/index';
import { reqAdvertPlaying, reqMajorAd, reqProducts } from '@/api/home/index';
import { reqCombinationlist } from '@/api/combination';
import {
  setBaseUrl,
  gioPlatform,
  gioJumpType,
  resetProductData,
  resetCoursePackage,
  handleJumpType,
  deepCopy,
} from '@/utils/tools';
import Foot from '@/components/foot/privacy.vue';
import HotCourseCard from '@/components/hotCourseCard/hotCourseCard.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import { mapState } from 'vuex';

export default {
  components: { HotCourseCard, Foot, CombinationCard },
  data() {
    return {
      searchVal: '',
      showCourse: false,
      courseMainList: [],
      FirstData: [],
      courseId: '',
      value: '',
      isSearching: false, // 是否正在搜索状态
      oldList: [], // 老课堂热搜词
      newList: [], // 新课堂热搜词
      historyList: [], // 历史搜索
      terminal: 3, // 1.PC；2.APP；3.H5；4.小程序
      terrace: 1,
      endPoint: 4, // 1 pc 2 app 4 h5 8 小程序
      pageNum: 1,
      id: '',
      skipType: '',
      totalPages: 0,
      loading: false,
      finished: false,
      gioType: 1, // 用于埋点 1 点击 2曝光
      adDataObject: {}, // 广告位数据
      courseInfoData: [], // 热门好课排行数据
      searchAdCode:
        process.env.VUE_APP_ENV === 'test' || process.env.VUE_APP_ENV === 'local'
          ? 'App25001'
          : 'App26011',
      searchPaihangAdCode:
        process.env.VUE_APP_ENV === 'test' || process.env.VUE_APP_ENV === 'local' ? '296' : '593',
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {
    // 监听用户信息变化，确保在用户信息加载完成后再获取历史搜索
    userInfo: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.getHistoryList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {
    this.NewhotSearch();
    this.getAdvert();
    this.getCourseAd();
  },
  destroyed() {},
  methods: {
    // 热门好课
    async getCourseAd() {
      const { code, data } = await reqMajorAd(this.searchPaihangAdCode);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      }
      this.resetProductData([]);
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};

      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = this.resetProductData(res?.data || [], 2);
        const resPackage = this.resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this.courseInfoData = allCourse;
      });
    },
    // 自定义数据格式
    resetProductData(courseList) {
      courseList.forEach((item) => {
        const copyItem = deepCopy(item);
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount &&
          productDiscountRespVO?.couponDiscount &&
          item.sellPrice > 0 &&
          !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice) +
              Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return courseList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount &&
          item.sellPrice > 0 &&
          !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
    // 请求广告位
    async getAdvert() {
      const res = await reqAdvertPlaying([this.searchAdCode]);
      if (res.code === 0 && res?.data) {
        this.adDataObject =
          res?.data?.find((item) => item.adCode === this.searchAdCode)
            ?.advertisingContentWebInfoRespVOS?.[0] || {};
        let adDataGio =
          res?.data?.find((item) => item.adCode === this.searchAdCode)
            ?.advertisingContentWebInfoRespVOS || [];
        this.gioEvent(adDataGio, (this.gioType = 2), { adPosition_var: '搜索页面' });
      }
    },

    jumpCourseDetail() {
      // 跳转类型：1.链接；2.产品；3.自定义产品列表；4.产品分类列表
      this.gioEvent(this.adDataObject, (this.gioType = 1), { adPosition_var: '搜索页面' });
      handleJumpType(this, this.adDataObject);
    },
    /**
     * 处理历史搜索项点击
     * @param {string} item - 历史搜索项内容
     */
    historyDetail(item) {
      // 将历史搜索项填充到搜索框
      this.value = item;
      // 执行搜索
      this.onSearch(item);
    },
    // 删除历史搜索
    deleteHistory() {
      // 显示确认弹窗
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认清空历史搜索吗？',
          confirmButtonText: '是',
          cancelButtonText: '否',
        })
        .then(async () => {
          // 用户点击确认按钮，执行删除操作
          const response = await reqDeleteHistory(this.historyList);
          if (response.code === 0) {
            this.historyList = [];
          }
        })
        .catch(() => {
          // 用户点击取消按钮，不执行任何操作
        });
    },
    changeEvent() {
      // 当输入框内容变化时，隐藏搜索结果部分
      this.isSearching = false;
    },
    resetPageParams() {
      this.pageNum = 1;
      this.totalPages = 0;
      this.finished = false; // 重置完成状态
    },
    onSearch(val) {
      this.resetPageParams();
      if (val) {
        this.searchVal = val;
        // 设置为搜索状态，隐藏历史搜索和 热搜词  广告位 热门好课排行
        this.isSearching = true;
      } else {
        return;
      }
      this.getSearchList();
      // eslint-disable-next-line no-undef
      gio('evar.set', 'search_evar', val);
      gio('track', 'search_event', {
        searchterm_var: val,
        platform_var: gioPlatform(),
      });
    },
    onCancel() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('closePage');
      } else {
        // 返回上一级
        this.$router.go(-1);
      }
    },
    /**
     * 清除搜索框内容
     * 清空搜索框并退出搜索状态，显示历史搜索和热搜词
     */
    clearSearch() {
      this.value = '';
      this.isSearching = false;
      this.searchVal = '';
      this.pageNum = 1;
      this.courseMainList = [];
      this.finished = false;
      this.loading = false;
    },
    // 历史搜索列表
    async getHistoryList() {
      if (!this.userInfo?.id) {
        return false;
      }
      const response = await reqHistoryList();
      if (response.code === 0) {
        this.historyList = response.data;
      }
    },
    // 新课堂热搜词
    async NewhotSearch() {
      // 判断是否在APP内部
      let terminal = null;
      if (this.$root.$data.isApp) {
        terminal = 2;
      } else if (this.$root.whatEev === 'miniprogram') {
        terminal = 2;
      } else {
        terminal = 3;
      }
      this.terminal = terminal;
      const response = await reqNewHotWord(this.terminal, this.terrace);
      if (response.code === 0) {
        this.newList = response.data;
        this.gioEvent(response.data, (this.gioType = 2));
      }
    },
    // // 老课堂热搜词点击
    // hotDetail(hot) {
    //   window.open(hot);
    // },
    // 新课堂热搜词点击量
    async HotQuantity() {
      const response = await reqHotClick(this.id);
      if (response.code === 0) {
        console.log('请求成功');
      }
    },
    // 新课堂热搜词点击
    AddhotDetail(item) {
      this.gioEvent(item, (this.gioType = 1));
      this.id = item.id;
      this.skipType = item.skipType;
      this.HotQuantity();
      // 跳转类型：1.链接；2.产品；3.自定义产品列表；4.产品分类列表
      const {
        skipType,
        skipUrl,
        productId,
        productCategoryId,
        productAttributeJson,
        openType,
        hotSearchWordDetailListVO,
      } = item;
      const { hotSearchWordDetailVOS } = hotSearchWordDetailListVO || {};

      switch (skipType) {
        case 1:
          if (this.$root.$data.isApp) {
            if (openType === 2) {
              this.$sendToApp('openBrowser', { url: skipUrl }, false);
            } else if (openType === 3) {
              this.$sendToApp('openTaobao', { url: skipUrl }, false);
            } else if (openType === 4) {
              this.$sendToApp('toTaoBaoBrowser', { url: skipUrl }, false);
            } else {
              this.$sendToApp('openNewWebView', { url: skipUrl }, false);
            }
            return;
          }
          // H5跳转url
          window.open(skipUrl);
          break;
        case 2:
          // 判断是否App
          if (this.$root.$data.isApp) {
            this.$sendToApp('goCourseDetail', Number(productId), false);
            return;
          }
          this.$router.push({
            path: '/courseDetail',
            query: {
              courseId: productId,
            },
          });
          break;
        case 3:
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              {
                url: `${setBaseUrl('')}/ark/productList?type=1&productId=${JSON.stringify(
                  hotSearchWordDetailVOS || [],
                )}&source=search`,
              },
              false,
            );
            return;
          }
          this.$router.push({
            path: '/productList',
            query: {
              type: 1,
              productId: JSON.stringify(hotSearchWordDetailVOS || []),
              source: 'search',
            },
          });
          break;
        case 4:
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              {
                url: `${setBaseUrl(
                  '',
                )}/ark/productList?type=2&productCategoryId=${productCategoryId}&productAttributeJson=${
                  productAttributeJson || ''
                }`,
              },
              false,
            );
            return;
          }
          this.$router.push({
            path: '/productList',
            query: {
              type: 2,
              productCategoryId,
              productAttributeJson,
            },
          });
          break;
        case 7:
          this.couonList(productId);
          break;
        default:
      }
    },
    couonList(coupons) {
      const couponList = coupons.split(',');
      if (couponList.length > 0) {
        couponList.map((key) => {
          this.getCoupons(key);
        });
      }
    },
    async getCoupons(key) {
      const res = await reqReceiveCoupon({
        couponId: String(key),
        isLink: 0,
        fitPlatform: 1,
        fitEndPoint: this.$root.$data.isApp ? 2 : 4,
        terminalMark: this.$global.terminalMark,
      });
      if (res.code === 0) {
        this.$toast('领取成功');
      } else {
        this.$toast(res.msg);
      }
    },
    // 获取搜索内容列表
    async getSearchList() {
      // 判断是否在APP内部
      let endPoint = null;
      if (this.$root.$data.isApp) {
        endPoint = 2;
      } else if (this.$root.whatEev === 'miniprogram') {
        endPoint = 2;
      } else {
        endPoint = 4;
      }
      this.endPoint = endPoint;
      const response = await reqSearchListNew(this.endPoint, this.pageNum, this.searchVal);
      if (response.code === 0 && response.data.data?.length > 0) {
        this.showCourse = false;
        this.FirstData = response.data.data;
        // 一共多少页
        this.totalPages = response.data.pages;
        const allProductList = [];
        const allPackageList = [];
        const recommendContentVOList = response.data.data;
        (recommendContentVOList || []).forEach((child) => {
          const { goodsType } = child;
          if (goodsType === 1) {
            allProductList.push(child.homePageProductWebRespVO);
          } else {
            allPackageList.push(child.packageBaseListWebRespVO);
          }
        });
        const resCourse = resetProductData(allProductList || []);
        const resPackage = resetCoursePackage(allPackageList || []);
        const allCourse = [];
        (recommendContentVOList || []).forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.goodsType === 1 ? course.productId : course.packageId;
            return id === child.goodsId;
          });
          findRes && allCourse.push(findRes);
        });

        if (this.pageNum > 1) {
          this.courseMainList = [...this.courseMainList, ...allCourse];
        } else {
          this.courseMainList = allCourse;
          this.getHistoryList(); //搜索时同步更新历史记录
        }
        this.loading = false;
        if (this.totalPages === this.pageNum) {
          this.finished = true;
        }
      } else {
        this.showCourse = true;
        this.getHistoryList(); //搜索时同步更新历史记录
      }
    },
    onLoad() {
      // 只有在有搜索关键词时才执行分页加载
      if (this.searchVal) {
        this.pageNum += 1;
        this.getSearchList();
      } else {
        this.loading = false;
      }
    },
    // jumpCourseDetail(courseInfo) {
    //   // 判断是否App
    //   if (this.$root.$data.isApp) {
    //     this.$sendToApp('goCourseDetail ', { courseId: courseInfo.productId }, false);
    //   } else {
    //     this.$router.push({
    //       path: '/courseDetail',
    //       query: {
    //         courseId: courseInfo.productId,
    //       },
    //     });
    //   }
    // },
    gioEvent(item, type, extraParams = {}) {
      if (type === 1) {
        const { title, skipType } = item;
        const adId = item.id;
        // 点击广告
        // eslint-disable-next-line
        gio('track', 'adClick_event', {
          adPosition_var: extraParams.adPosition_var || '热搜词', // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      } else {
        const sortList = [];
        const adIdList = [];
        const adNameList = [];
        const jumpTypeList = [];
        if (!item) {
          return;
        }
        item.forEach((element) => {
          sortList.push(element.sort);
          adIdList.push(element.id);
          adNameList.push(element.title);
          // eslint-disable-next-line
          const jumpType = gioJumpType(element.skipType);
          // element.skipType === 1 ? '链接' : element.skipType === 2 ? '产品' : element.skipType === 3 ? '自定义产品列表' : element.skipType === 4 ? '产品分类列表' : element.skipType === 5 ? '套餐' : '其他';
          jumpTypeList.push(jumpType);
        });
        // 广告曝光
        // eslint-disable-next-line
        gio('track', 'adShown_event', {
          adPosition_var: extraParams.adPosition_var || '热搜词', // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adIdList.toString(), // 广告ID
          adName_var: adNameList.toString(), // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: jumpTypeList.toString(), // 跳转类型
          platform_var: gioPlatform(),
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.searchPage {
  width: 100%;
  padding-bottom: 100px;
  background: #fefeff;

  .searchPageWarrp {
    min-height: 100vh;

    .searchHead {
      .searchInput {
        ::v-deep .van-search {
          padding: 10px 20px;
          background: #fefeff;

          .van-search__content {
            background: #fafafa;
            border-radius: 4px;

            .van-icon-search {
              font-size: 14px;

              &::before {
                width: 0.32rem;
                height: 0.32rem;
                background: url(../../assets/img/search/searchIcon.png);
                background-size: 100% 100%;
                content: '';
              }
            }

            input.van-field__control {
              text-indent: 3px;

              &::placeholder {
                color: $fontColorGray;
                font-size: 0.32rem;
              }
            }

            .van-icon-clear {
              width: 0.4rem;
              height: 0.4rem;
              margin-right: 0;
              background: url(../../assets/img/search/icon_clear.png) no-repeat;
              background-size: 100% 100%;

              &::before {
                content: none;
              }
            }
          }

          .van-search__action {
            padding: 0 0 0 16px;
            color: $fontColorBlack;
            font-weight: 500;
            font-size: 0.38rem;
          }
        }
      }
    }
    .searchHistory {
      box-sizing: border-box;
      padding: 44px 16px 0 30px;
      .searchHistoryTittle {
        display: flex;
        justify-content: space-between;
        h2 {
          padding-bottom: 15px;
          color: $fontColorBlack;
          font-weight: 500;
          font-size: 29px;
          line-height: 40px;
        }
        img {
          display: block;
          width: 48px;
          height: 48px;
        }
      }

      .searchHistoryContent {
        position: relative;
        max-height: 146px; /* 两行的高度：(58px行高 + 15px上边距) * 2 = 146px */
        overflow: hidden;

        ul {
          display: flex;
          flex-wrap: wrap;

          li {
            display: inline-block;
            margin: 15px 15px 0 0;
            padding: 0 16px;
            font-size: 25px;
            line-height: 58px;
            background: #fafafa;
            border-radius: 7px;
          }
        }
      }
    }

    .searchHot {
      box-sizing: border-box;
      padding: 44px 16px 0 30px;
      img {
        display: block;
        width: 180px;
        height: 36px;
      }

      h2 {
        padding-bottom: 15px;
        color: $fontColorBlack;
        font-weight: 500;
        font-size: 29px;
        line-height: 40px;
      }

      .searchHotContent {
        ul {
          display: flex;
          flex-wrap: wrap;

          li {
            display: inline-block;
            margin: 15px 15px 0 0;
            padding: 0 16px;
            font-size: 25px;
            line-height: 58px;
            background: #fafafa;
            border-radius: 7px;
          }
        }
      }
    }

    .searchListContent {
      padding-bottom: 60px;

      .noCourse {
        padding-top: 300px;

        > div {
          text-align: center;

          img {
            width: 320px;
            height: 320px;
          }

          > div {
            color: $fontColorGray;
            font-weight: 500;
            font-size: 22px;
            line-height: 31px;
          }
        }
      }

      .courseMain {
        width: 678px;
        margin: 0 auto;
        padding-top: 36px;

        .card {
          box-sizing: border-box;
          width: 100%;
        }
      }
    }
  }
}

.demo {
  padding: auto;
}
.adbox {
  width: 678px;
  height: 100px;
  margin: 36px auto 0;
  background: #d8d8d8;
  border-radius: 14px;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.hotCourseSection {
  margin-top: 58px;
  padding: 0 36px;
  .hotCourseTitle {
    display: block;
    width: 192px;
    height: 36px;
    margin: 30px 0;
  }
  h2 {
    margin: 30px 0;
    color: $fontColorBlack;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
  }
}
::v-deep .van-field__clear {
  display: none;
}

::v-deep .common-foot {
  position: fixed;
  bottom: 0;
}

/* eslint-enable */
</style>
